import { getUnsafeDateNow } from '../utils/utils';
export class HttpTokenService {
    constructor(http, logger) {
        this.http = http;
        this.logger = logger;
        this.lastResult = null;
    }
    async issueAccessToken() {
        try {
            this.logger.logInformation('HTTP Token Service: Requesting access token...');
            // parse JWT and do not request a new one, if still valid
            if (this.lastResult !== null) {
                const jwt = this.lastResult.split('.');
                const payload = JSON.parse(jwt[1]);
                const now = getUnsafeDateNow().getTime() / 1000;
                if (payload.exp >= now + HttpTokenService.validityThresholdInSeconds) {
                    this.logger.logInformation('HTTP Token Service: A still valid token is already present.');
                    return this.lastResult;
                }
            }
            // request new
            this.logger.logInformation('HTTP Token Service: Requesting new access token...');
            const result = await this.http.post('jwt', null);
            // save in case of a future api call error
            this.lastResult = result.token;
            return result.token;
        }
        catch (ex) {
            this.logger.logWarning(`HTTP Token Service: ${ex}`);
            // return last known result
            if (this.lastResult !== null) {
                this.logger.logInformation('HTTP Token Service: Returning last result...');
                return this.lastResult;
            }
            throw ex;
        }
    }
}
HttpTokenService.validityThresholdInSeconds = 5 * 60;
